import { authHeader } from '../utils/authHeader';
import { pedir } from '../utils/respuestaApi';

import { API_BASE_URL } from '../config';

const jsonHeaders = () => ({ 'Content-Type': 'application/json', ...authHeader() });

export const POLL_COLORS = [
  '#0077c8', '#00a0d0', '#6366f1', '#8b5cf6', '#ec4899',
  '#ef4444', '#f59e0b', '#22c55e', '#14b8a6', '#64748b'
];

export const getSpacePolls = async (spaceId) =>
  pedir(
    `${API_BASE_URL}/api/polls/space/${spaceId}`,
    { headers: { ...authHeader() } },
    'No se pudieron cargar las encuestas del espacio'
  );

// Todas las encuestas de todos los espacios: se usa en la pantalla
// principal, donde no hay un espacio fijo seleccionado.
export const getAllPolls = async () =>
  pedir(
    `${API_BASE_URL}/api/polls`,
    { headers: { ...authHeader() } },
    'No se pudieron cargar las encuestas'
  );

export const createPoll = async (poll) =>
  pedir(
    `${API_BASE_URL}/api/polls`,
    { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(poll) },
    'No se pudo crear la encuesta'
  );

export const votePoll = async (pollId, optionId) =>
  pedir(
    `${API_BASE_URL}/api/polls/${pollId}/vote`,
    { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ optionId }) },
    'No se pudo registrar tu voto'
  );

export const setPollStatus = async (pollId, status) =>
  pedir(
    `${API_BASE_URL}/api/polls/${pollId}`,
    { method: 'PATCH', headers: jsonHeaders(), body: JSON.stringify({ status }) },
    'No se pudo cambiar el estado de la encuesta'
  );

export const setPollPinned = async (pollId, isPinned) =>
  pedir(
    `${API_BASE_URL}/api/polls/${pollId}`,
    { method: 'PATCH', headers: jsonHeaders(), body: JSON.stringify({ isPinned }) },
    'No se pudo fijar la encuesta'
  );

export const deletePoll = async (pollId) =>
  pedir(
    `${API_BASE_URL}/api/polls/${pollId}`,
    { method: 'DELETE', headers: { ...authHeader() } },
    'No se pudo eliminar la encuesta'
  );
